<template lang="pug">
#cte
	CteTopBar(:title="'Industry Sectors'")
	.page
		//- loading animation
		.loading-circles(v-if='loadingSectors')
			span
			span
			span
		CteSectors
	add-sector-modal
</template>

<script>
import CteTopBar from '@/components/CteTopBar';
import ProfileImage from '@/components/ProfileImage';
import CteSectors from '@/components/CteSectors';
import AddSectorModal from '@/components/AddSectorModal';

export default {
  name       : 'cte-sectors',
  components : {
    CteTopBar,
    ProfileImage,
    CteSectors,
    AddSectorModal
  },

  computed : {
    loadingSectors() {
      return this.$store.getters.loadingSectors;
    },
  },
};

</script>

<style lang="scss" scoped>
#cte {
	height: 100vh;
	// overflow: auto;
	background: white;
	display: flex;
	flex-direction: column;

	.page {
		flex: 1;
		overflow: auto;
		z-index: 5;
	}
}
</style>
